new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    }
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const bannerHome = document.querySelector('.home__banner');
    if (bannerHome) {
        let bannerImg = document.querySelector('.home__banner--figure img');
        if (bannerImg) {
            let sizeBanner = bannerImg.getBoundingClientRect().height;
            bannerHome.style.height = sizeBanner + 'px';
        }
    }

    const brands = document.querySelector('#brands-carousel');
    if (brands) {
        $('#brands-carousel').slick({
            arrows: false,
            dots: true,
            infinite: false,
            autoplay: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    }
                },
            ]
        });
    }

    waitForElementToExist('#lateral-banners__content-1').then(element => {
        $('#lateral-banners__content-1').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    });

    waitForElementToExist('#lateral-banners__content-2').then(element => {
        $('#lateral-banners__content-2').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    });

    waitForElementToExist('.first-vitrine').then(element => {
        $('#product_list:not(.no-carrousel)').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 2,
            slidesPerRow: 2,
            speed: 700,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        dots: false,
                        slidesToShow: 4,
                        rows: 1,
                        slidesPerRow: 1,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.second-vitrine').then(element => {
        $('#product_list-2:not(.no-carrousel)').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 2,
            slidesPerRow: 2,
            speed: 700,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        dots: false,
                        slidesToShow: 4,
                        rows: 1,
                        slidesPerRow: 1,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.third-vitrine').then(element => {
        $('#product_list-6:not(.no-carrousel)').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 2,
            slidesPerRow: 2,
            speed: 700,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        dots: false,
                        slidesToShow: 4,
                        rows: 1,
                        slidesPerRow: 1,
                    }
                }
            ]
        });
    });

    
    $('#product_list-3').slick({
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 2,
        slidesPerRow: 2,
        speed: 700,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: false,
                    slidesToShow: 4,
                    rows: 1,
                    slidesPerRow: 1,
                }
            }
        ]
    });

    waitForElementToExist('.choose-goal').then(element => {
        $('#choose-goal__products-1').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 700,
            appendArrows: ".choose-goal__arrows-1",
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        });

        $('#choose-goal__products-2').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 700,
            appendArrows: ".choose-goal__arrows-2",
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        });

        $('#choose-goal__products-3').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 700,
            appendArrows: ".choose-goal__arrows-3",
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        });

        $('#choose-goal__products-4').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 700,
            appendArrows: ".choose-goal__arrows-4",
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        });

        $('#choose-goal__products-1, #choose-goal__products-2, #choose-goal__products-3, #choose-goal__products-4').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });

        let rotationNames = element.querySelectorAll('.choose-goal__titles h4');
        let initVitrine = element.querySelectorAll('.choose-goal__item');
        initVitrine = Array.from(initVitrine);

        if (rotationNames.length && initVitrine.length) {
            initVitrine[0].classList.add('active');
            rotationNames[0].classList.add('active');

            function activeTab(index) {
                initVitrine.forEach((content) => content.classList.remove('active'));
                rotationNames.forEach((content) => content.classList.remove('active'));

                initVitrine[index].classList.add('active');
                rotationNames[index].classList.add('active');

                // Lista de IDs dos carrosséis
                const carouselIds = [
                    '#choose-goal__products-1',
                    '#choose-goal__products-2',
                    '#choose-goal__products-3',
                    '#choose-goal__products-4'
                ];

                // Atualiza apenas o carrossel correspondente ao índice
                const currentCarouselId = carouselIds[index];
                const $carousel = $(currentCarouselId);

                if ($carousel.hasClass('slick-initialized')) {
                    const totalItems = $carousel.slick('getSlick').slideCount;
                    const $countFirst = $('.count-content .count-first');
                    const $countEnd = $('.count-content .count-end');

                    $countEnd.text(('0' + totalItems));

                    // Desvincula qualquer listener anterior antes de reatribuir
                    $carousel.off('afterChange').on('afterChange', function (event, slick, currentSlide) {
                        $countFirst.text(('0' + (currentSlide + 1)));
                    });

                    // Força o refresh do slick
                    $carousel.slick('refresh');
                }
            }

            rotationNames.forEach((itemMenu, index) => {
                itemMenu.addEventListener('click', (e) => {
                    e.preventDefault();
                    activeTab(index);
                });
            });

            // Initial update for the first active tab
            activeTab(0);
        }



    });




    $('.banner-instagram__list').slick({
        arrows: false,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 2,
        slidesPerRow: 2,
        speed: 700,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    rows: 1,
                    slidesPerRow: 1,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    rows: 1,
                    slidesPerRow: 1,
                }
            },
        ]
    });

    $('#carrousel-products-video').slick({
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: true,
                    autoplay: true,
                    speed: 1000
                }
            }
        ]
    });

    $('#product_list, #product_list-2, #product_list-3, #carrousel-products-video').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function (element) {
                setTimeout(function () {
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                }, 200);
            }
        });
    });

    waitForElementToExist('#carrousel-product-ratings').then(element => {
        $('#carrousel-product-ratings').slick({
            dots: true,
            appendArrows: $('.product-ratings .append-arrow'),
            arrows: true,
            autoplay: true,
            infinite: true,
            mobileFirst: true,
            speed: 1000,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: false,
                  }
                }
            ]
        });
    });

    waitForElementToExist('.banner-categoria').then(element => {
        $('.banner-categoria__content').slick({
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 3,
            slidesPerRow: 1,
            slidesToScroll: 1,
            rows: 2,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                        slidesPerRow: 1,
                        dots: false,
                        arrows: true,
                        rows: 1
                    }
                },
                {
                    breakpoint: 1150,
                    settings: {
                        slidesToShow: 6,
                        slidesPerRow: 1,
                        dots: false,
                        arrows: true,
                        rows: 1
                    }
                }
            ]
        });
    });


    $('#carrousel-banner-categories').slick({
        arrows: true,
        prevArrow: $(".text-content__arrow .prev"),
        nextArrow: $(".text-content__arrow .next"),
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    speed: 1000,
                }
            }
        ]
    });
})